import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';

const API_BASE = '/api';

const AdminRoute = ({ children }) => {
  const [status, setStatus] = useState('loading'); // loading | admin | denied

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      setStatus('denied');
      return;
    }

    fetch(`${API_BASE}/auth/verify`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((r) => {
        if (!r.ok) throw new Error('Unauthorized');
        return r.json();
      })
      .then((data) => {
        setStatus(data.user && data.user.role === 'admin' ? 'admin' : 'denied');
      })
      .catch(() => setStatus('denied'));
  }, []);

  if (status === 'loading') {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div className="spinner-border" role="status" style={{ color: '#FF385C' }}>
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (status === 'denied') {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminRoute;
